<nb-card class="main">
	<nb-card-body>
		<div class="header">
			<h5>{{ 'HELP_PAGE.REMOVE_BASE' | translate }}</h5>
			<nb-icon icon="close-outline" (click)="closeDialog()"></nb-icon>
		</div>
		<span class="label">{{ 'HELP_PAGE.ARE_YOU_SURE' | translate }}</span>
		<div class="save-button">
			<button status="danger" (click)="deleteBase()" nbButton>
				{{ 'BUTTONS.DELETE' | translate }}
			</button>
		</div>
	</nb-card-body>
</nb-card>
